require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-64-stunning-beauty-website-designs-for-your-inspiration.json") })
        }
      }, "path---blog-64-stunning-beauty-website-designs-for-your-inspiration");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-64-stunning-beauty-website-designs-for-your-inspiration!./.cache/json/blog-64-stunning-beauty-website-designs-for-your-inspiration.json
// module id = 415
// module chunks = 231608221292675